module.exports = __webpack_public_path__ + "logo-stripe.png?0ce333a194bdcce36a2775c23ee80b62";